import ApiService from "../../api.service";
import appConfig from "../../../../app-config";
import { CommonStorage } from "../../../storage";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const SettingsService = {
  AllSettings: [],

  async get(params) {
    return await ApiService.oDataGet(params);
  },

  async getAll() {
    const requestFeatureData = {
      url: "api/ApplicationFeatureSetting",
      filter: `Inactive eq 'N'`,
      select: "ApplicationFeatureCode,Inactive,ScopeCode,ScopeValue,SettingName,SettingValue"
    };

    return new Promise(async (resolve, reject) => {
      try {
        var result = await ApiService.oDataGet(requestFeatureData);
        this.AllSettings = result.data.value;
        resolve(result);
      } catch (error) {
        reject(error);
      }
    });
  },

  async getBySettingName(settingName) {
    if (this.AllSettings.length === 0) {
      await this.getAll();
    }

    let settings = this.AllSettings.filter(
      (x) => x.SettingName === settingName
    );

    return new Promise(async (resolve) => {
      resolve({
        data: {
          value: settings,
        },
      });
    });
  },
  async getBySettingByApplicationFeatureCode(applicationFeatureCode) {
    if (this.AllSettings.length === 0) {
      await this.getAll();
    }

    let settings = this.AllSettings.filter(
      (x) => x.ApplicationFeatureCode === applicationFeatureCode
    );

    return new Promise(async (resolve) => {
      resolve({
        data: {
          value: settings,
        },
      });
    });
  },
  async saveUseInSettingsValues(screens) {

    if (this.AllSettings.length === 0) {
      await this.getAll();
    }

    screens.forEach(element => {
      let settings = this.AllSettings.filter(
        (x) => x.SettingName === element
      );

      if (settings.length > 0) {
        CommonStorage.saveItems(element, settings[0].SettingValue);
      }
    });
  }
};

export default SettingsService;

export { SettingsService };
